import { message } from "antd"
import i18n from "../services/i18n"

// tog'a #274/#276 (2026-10-20): telefonda uzun formada «Сохранить» bosilganda majburiy maydon (masalan, manzil) bo'sh bo'lsa
// xato yuqorida — ekrandan tashqarida — chiqardi, tugma «ishlamayapti» bo'lib ko'rinardi. Endi HAR QANDAY antd formada:
// yuborishdan keyin xato bor bo'lsa — birinchi xatoli maydonga suriladi va qaysi maydonlar to'ldirilmagani yoziladi.
export function installFormErrorScroll() {
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target as HTMLElement
      if (!form?.classList?.contains("ant-form")) return
      // antd tekshiruvi asinxron — xatolar chizilishini kutamiz
      setTimeout(() => {
        const bad = Array.from(form.querySelectorAll<HTMLElement>(".ant-form-item-has-error"))
        if (!bad.length) return
        bad[0].scrollIntoView({ behavior: "smooth", block: "center" })
        const nomlar = bad
          .map((el) => (el.querySelector(".ant-form-item-label label")?.textContent || "").replace(/[*:]/g, "").trim())
          .filter(Boolean)
        message.warning({
          content: `${i18n.t("formFixFields")}${nomlar.length ? ": " + Array.from(new Set(nomlar)).slice(0, 5).join(", ") : ""}`,
          key: "form-error-scroll",
          duration: 4,
        })
      }, 250)
    },
    true
  )
}
